// 引入api
import { fun_PostAction } from "@/api";
// 默认导出
export default {
  name: "ChooseExpert",
  // 数据存储对象
  data: () => {
    return {
      // 列表loading初始状态
      loading: false,
      // 打开窗口的类型 , 默认指定专家assignExpert,  抽取结果是添加结果专家 extractExpert
      openType: null,
      // 采购单位和代理机构弹出框
      form: {
        expertName: null,
        idNumber: null,
        databaseType: "staff"
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "姓名：",
          value: "expertName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "身份证号：",
          value: "idNumber",
          placeholder: "请输入"
        }
      ],
      // 查询表单字段
      searchForm: {
        corpName: null // projectCode
      },
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "expertName"
        },
        {
          label: "性别",
          prop: "expertGenderName"
        },
        {
          label: "身份证号",
          prop: "idNumber"
        },
        {
          label: "联系方式",
          prop: "expertTel"
        },
        {
          label: "专业",
          prop: "professionNames"
        },
        {
          label: "工作单位",
          prop: "workPlace"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数据
      multipleSelection: [],
      dialogVisibles: false // 采购单位或招标代理弹窗显示标识
    };
  },
  // 模板编译完成
  mounted() {},

  // 自定义方法
  methods: {
    /**
     * 打开弹窗, 调用查询
     * @param {*} e 查询的企业类型
     * @author zhouy
     */
    fun_OpenDialog(openType) {
      this.openType = openType;
      this.dialogVisibles = true;
      this.fun_GetList();
    },
    /**
     * 获取采购单位/代理
     * @author zhouy
     */
    async fun_GetList() {
      // 打开loading
      this.loading = true;
      let res = await fun_PostAction("/expert/list", {
        ...this.form,
        ...this.reqPageData
      });
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        const { records, total } = data;
        // 回显table
        this.tableData = records;
        // 回显分页总数
        this.total = total;
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
      }
      // 关闭loading
      this.loading = false;
    },
    /**
     * 代理传值
     * @author 付翔
     */
    fun_FixExpert() {
      // 如果是选择指定专家, 回填指定专家信息
      if (this.openType === "assignExpert") {
        // 如果没有勾选专家
        if (this.multipleSelection.length === 0) {
          this.$message.error("请勾选专家！");
          return false;
        }
        this.$emit("fun_SetChooseExpert", this.multipleSelection);
      } else {
        // 如果没有勾选专家
        if (this.multipleSelection.length === 0) {
          this.$message.error("请勾选专家！");
          return false;
        }
        // 如果没有勾选专家
        if (this.multipleSelection.length > 1) {
          this.$message.error("只能选择一位专家！");
          return false;
        }
        this.$emit("fun_SetExtractExpert", this.multipleSelection[0]);
      }

      this.fun_CloseDialog();
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     * @author 滕威
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 关闭手动选择专家一览弹窗
     */
    fun_CloseDialog() {
      this.reqPageData = {
        current: 1,
        size: 10
      };
      this.total = 0;
      this.form.expertName = null;
      this.form.idNumber = null;
      this.tableData = [];
      this.multipleSelection = [];
      this.dialogVisibles = false;
    }
  }
};
